import { useQuery } from '@tanstack/react-query'
import { deskWaitingQuery } from '../api/desk'

export function DeskConsolePage() {
  const { data } = useQuery({ ...deskWaitingQuery(), refetchInterval: 60000 })
  const counts = (data?.counts ?? {}) as Record<string, number>

  return (
    <div className="container" style={{ paddingTop: 24 }}>
      <h2>Waiting on a person</h2>
      <p>
        Plan: {counts.waiting_plan ?? 0} · Approval: {counts.waiting_approval ?? 0} · Order: {counts.waiting_order ?? 0} · User:{' '}
        {counts.waiting_user ?? 0}
      </p>
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Ticket</th>
            <th>Subject</th>
            <th>State</th>
            <th>Age</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {((data?.rows ?? []) as Array<Record<string, unknown>>).map((row) => (
            <tr key={String(row.run_id)}>
              <td>#{String(row.ticket_id)}</td>
              <td>{String(row.subject ?? '')}</td>
              <td>{String(row.state ?? '')}</td>
              <td>{Math.floor(Number(row.age_seconds ?? 0) / 60)}m</td>
              <td>
                <a href={`/app/${String(row.href ?? '')}`}>Open</a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
